import React, { createContext, useCallback, useMemo, useState } from 'react';

type ContextType = {
  closePortal: (portalId: string) => void;
  hasOpenPortals: boolean;
  openPortal: (portalId: string) => void;
};

const defaultContext: ContextType = {
  closePortal(_id: string) {},
  hasOpenPortals: false,
  openPortal(_id: string) {}
};

const PortalContext = createContext(defaultContext);

export function PortalContextProvider({ children }: React.PropsWithChildren) {
  const [openPortals, setOpenPortals] = useState<string[]>([]);

  const openPortal = useCallback((portalId: string) => {
    setOpenPortals(portals => portals.concat(portalId));
  }, []);

  const closePortal = useCallback((portalId: string) => {
    setOpenPortals(portals => portals.filter(v => v !== portalId));
  }, []);

  const value = useMemo<ContextType>(
    () => ({
      closePortal,
      hasOpenPortals: openPortals.length > 0,
      openPortal
    }),
    [closePortal, openPortal, openPortals.length]
  );

  return (
    <PortalContext.Provider value={value}>{children}</PortalContext.Provider>
  );
}

PortalContextProvider.displayName = 'PortalContextProvider';

export default PortalContext;
